module.exports = __webpack_public_path__ + "img/download-top-button.e7ca017e.png";